<!--
    RENDERING A PERSONALIZED GREETING MESSAGE.
    USES DATA BINDING TO DYNAMICALLY DISPLAY THE TIME OF DAY AND THE USERNAME.
    GREETS USER WITH GOOD + TIMEOF DAY (calculated on created()).
    GRABS USER NAME FROM LOCAL STORAGE. STORED DURING LOGIN.
    COMPONENT PART OF © AREA 19, OCG WEB APP.
    DEVELOPED IN MONTREAL, QC, CANADA.
    JULY 2023.
  -->
<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { useAppState } from '../store/ocg-app-state';

defineProps({
  username: String,
});

const appState = useAppState();
const timeofday = ref<string>('');

onMounted(() => {
  timeofday.value = appState.timeOfDay;
});
</script>

<template>
  <div class="text-center">
    <h1>Good {{ timeofday }},</h1>

    <h1>{{ username }}</h1>
  </div>
</template>
